var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame1000005913(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 8,
    fill: "url(#paint0_linear_580_343)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_580_343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 25.5664C31.2847 25.5664 28.2617 28.5894 28.2617 32.3047C28.2617 36.02 31.2847 39.043 35 39.043C38.7153 39.043 41.7383 36.02 41.7383 32.3047C41.7383 28.5894 38.7153 25.5664 35 25.5664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0787 31.0268L54.6489 30.2463C54.1567 28.2038 53.3539 26.2665 52.2537 24.47L53.3579 22.2617C53.6172 21.7432 53.5158 21.1167 53.1051 20.7061L49.2938 16.8948C48.8818 16.4828 48.2581 16.3841 47.7382 16.642L45.5285 17.7476C43.8887 16.7461 42.1107 15.988 40.226 15.4866L38.9008 12.7449C38.6718 12.2882 38.206 12 37.6953 12H32.3047C31.794 12 31.3282 12.2882 31.0992 12.7449L29.7739 15.4867C27.8892 15.9881 26.1112 16.7462 24.4714 17.7477L22.2617 16.6421C21.7405 16.3802 21.1181 16.4816 20.7061 16.8949L16.8948 20.7061C16.4842 21.1167 16.3828 21.7432 16.642 22.2617L17.7476 24.4714C16.7461 26.1112 15.988 27.8892 15.4866 29.7739L12.7449 31.0992C12.2882 31.3282 12 31.794 12 32.3047V37.6953C12 38.206 12.2882 38.6718 12.7449 38.9008L15.4867 40.2261C15.942 41.9278 16.6198 43.561 17.5081 45.0969L16.5685 47.9146C16.4079 48.3989 16.5342 48.9332 16.8949 49.2939L20.7062 53.1052C21.0681 53.4659 21.5998 53.5922 22.0855 53.4316L24.9032 52.4919C26.597 53.475 28.3881 54.1975 30.2465 54.6477L31.0269 57.0788C31.2098 57.6289 31.7243 58 32.3047 58H37.6953C38.2757 58 38.7903 57.6289 38.9732 57.0787L39.7537 54.6476C41.6121 54.1975 43.4032 53.4749 45.097 52.4919L47.9147 53.4315C48.4003 53.5921 48.9347 53.4658 49.294 53.1051L53.1053 49.2938C53.4659 48.9331 53.5923 48.3988 53.4317 47.9145L52.492 45.0968C53.4751 43.403 54.1976 41.6119 54.6477 39.7535L57.0789 38.9731C57.6289 38.7903 58 38.2757 58 37.6953V32.3047C58 31.7243 57.6289 31.2098 57.0787 31.0268ZM35 49.8242C26.8259 49.8242 20.1758 43.1741 20.1758 35C20.1758 26.8259 26.8259 20.1758 35 20.1758C43.1741 20.1758 49.8242 26.8259 49.8242 35C49.8242 43.1741 43.1741 49.8242 35 49.8242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5543 39.0649C39.8549 40.7127 37.548 41.7381 35.0001 41.7381C32.4523 41.7381 30.145 40.7127 28.4458 39.0649C27.3323 40.1657 26.4779 41.53 26.0117 43.0686C28.2337 45.5415 31.4214 47.1287 35.0001 47.1287C38.5782 47.1287 41.7656 45.5421 43.9874 43.0699C43.5216 41.5306 42.6675 40.1658 41.5543 39.0649Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_580_343",
    x1: 1.5,
    y1: 3,
    x2: 70,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#981A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124B6A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_580_343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1000005913);
export default __webpack_public_path__ + "static/media/Frame1000005913.17fd1be7d6c84c074699604215d5b425.svg";
export { ForwardRef as ReactComponent };